import { axiosInstance } from "./AxiosDefaults";

export const uploadFile = (file: any): Promise<any> => {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post("/files/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getOneFile = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/files/storage`}/${id}`);
};

export const deleteFile = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/files"}/${id}`);
};

export const uploadPdfToDatabase = async (pdfBlob: Blob) => {
  try {
    await uploadFile(new File([pdfBlob], "document.pdf"));
  } catch (error) {
    console.error("Error uploading PDF:", error);
  }
};

export const uploadAndSendPdf = (
  blob: any,
  registrationId: any
): Promise<any> => {
  // Slanje PDF-a na API
  const formData = new FormData();
  formData.append("pdf", blob, "document.pdf"); // Priložite PDF kao datoteku
  return axiosInstance.post(`/files/upload/pdf/${registrationId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
